// A dependency-free handle on browser Sentry. The SDK loads after the page is
// interactive (see instrumentation-client.ts), so shared UI never pulls it into
// a route's initial JavaScript. Calls made before it loads run in order once it
// does; if it cannot load, they are dropped.
type BrowserSentry = typeof import("@sentry/tanstackstart-react");

let sentry: BrowserSentry | undefined;
let unavailable = false;
const queued: Array<(sentry: BrowserSentry) => void> = [];

export function withSentry(task: (sentry: BrowserSentry) => void) {
  if (sentry) task(sentry);
  else if (!unavailable) queued.push(task);
}

export function sentryReady(loaded: BrowserSentry) {
  sentry = loaded;
  for (const task of queued.splice(0)) task(loaded);
}

export function sentryUnavailable() {
  unavailable = true;
  queued.length = 0;
}
